import { CLASS_NAME_PREFIX } from "../__config__/constants";

export const ToggleClassName = CLASS_NAME_PREFIX + "-toggle-button";
export const ToggleIconClassName = ToggleClassName + "__icon";
